import React, { useContext } from 'react';
import { Divider } from 'semantic-ui-react';
import SearchContext from '../../../../contexts/SearchContext';
import TagAndHighlights from './TagAndHighlights';
import MatchedProjects from './MatchedProjects';

const ExtraInfo = ({ expert }) => {
  const { searchResult } = useContext(SearchContext);
  const searchData = searchResult?.items.find((i) => i.item.id === expert.id);
  return (
    <div className="extra-info">
      <TagAndHighlights expert={expert} searchData={searchData} />
      <Divider />
      <MatchedProjects expert={expert} searchData={searchData} />
    </div>
  );
};

export default ExtraInfo;
